module.exports = __webpack_public_path__ + "img/strand.c47213e1.png";